import _ from "lodash";
import Helpers from "../helperFunctions";

const getStringFromQueryObject = (queryParams) => {
    const searchParams = new URLSearchParams('');
    for (const key in queryParams) {
        const value = queryParams[key];
        !_.isNil(value) && searchParams.append(key, value);
    }

    return searchParams.toString();
}

export const fetchRequest = async (baseUrl, apiPath = '', requestType = 'GET', request = {}) => {
    const { headers, body, queryParams, dynamicContentType } = request;
    let url = `${baseUrl}${apiPath ? `/${apiPath}` : ''}`;

    if (queryParams) {
        const queryString = getStringFromQueryObject(queryParams);
        url += `?${queryString}`;
    }

    const response = await fetch(url, {
        method: requestType,
        headers: dynamicContentType ? (headers || {}) : {
            ...(headers || {}),
            'Content-Type': 'application/json'
        },
        body: body ? JSON.stringify(body) : null,
    }).then(Helpers.checkStatus);

    return response.json();
}